import CustomLink, { CustomLinkProps } from 'components/shared/CustomLink';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import styles from './styleConstants.module.css';

const cx = (...classes: (string | undefined | false | null)[]) =>
  classes.filter(Boolean).join(' ');

export const PrimaryLink = forwardRef<HTMLAnchorElement, CustomLinkProps>(
  function PrimaryLink({ className, ...props }, ref) {
    return (
      <CustomLink
        ref={ref}
        className={cx(styles.primaryLink, className)}
        {...props}
      />
    );
  },
);

export const PrimaryButton = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<'button'>
>(function PrimaryButton({ className, ...props }, ref) {
  return (
    <button
      ref={ref}
      className={cx(styles.primaryButton, className)}
      {...props}
    />
  );
});

export const P_Lg = forwardRef<
  HTMLParagraphElement,
  ComponentPropsWithoutRef<'p'>
>(function P_Lg({ className, ...props }, ref) {
  return <p ref={ref} className={cx(styles.pLg, className)} {...props} />;
});

export const H2_Lg = forwardRef<
  HTMLHeadingElement,
  ComponentPropsWithoutRef<'h2'>
>(function H2_Lg({ className, ...props }, ref) {
  return <h2 ref={ref} className={cx(styles.h2Lg, className)} {...props} />;
});

export const P = forwardRef<HTMLParagraphElement, ComponentPropsWithoutRef<'p'>>(
  function P({ className, ...props }, ref) {
    return <p ref={ref} className={cx(styles.p, className)} {...props} />;
  },
);
